const DEFAULT_DISPLAY_NAME = 'Community member';

export function isValidDisplayName(displayName) {
    if (typeof displayName !== 'string') return false;
    const name = displayName.trim();
    return name.length >= 2 && name.length <= 32 && !name.includes('@');
}

export function getUserDisplayName(user) {
    const metadata = user?.user_metadata ?? {};
    const displayName = metadata.display_name ?? metadata.username;
    return isValidDisplayName(displayName)
        ? displayName.trim()
        : DEFAULT_DISPLAY_NAME;
}

export function getPublicAuthorName(author) {
    if (typeof author !== 'string' || !author.trim() || author.includes('@')) {
        return DEFAULT_DISPLAY_NAME;
    }
    return author.trim();
}
